import AboutUsComponent from "../components/about-us/AboutUsComponent";

const About: React.FC = () => {
  return (
    <>
      <AboutUsComponent />
    </>
  );
};
export default About;